window.DocRecurring = {

	formConditions : {
        gocardless : {
            model		: false,
            third		: false,
            mode       	: false,
        },
        stripe : {
            model		: false,
            third		: false,
            mode		: false,
        }
	},

    directdebitAvailable : {
        stripe      : false,
        gocardless  : false
    },

    freqMore_label : {
		xdays	: Loc.g('Nombre de jours'),
		month	: Loc.g('Jour dans le mois'),
		week	: Loc.g('Jour dans la semaine')
	},
	freqMore_values : {
		weekly	: [
			Loc.g('Lundi'),
			Loc.g('Mardi'),
			Loc.g('Mercredi'),
			Loc.g('Jeudi'),
			Loc.g('Vendredi'),
			Loc.g('Samedi'),
			Loc.g('Dimanche')
		],
		monthly	: [
			'1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31'
		],
		monthlyMoreFirst : {
			'-1':	Loc.g('Premier lundi'),
			'-2':	Loc.g('Premier mardi'),
			'-3':	Loc.g('Premier mercredi'),
			'-4':	Loc.g('Premier jeudi'),
			'-5':	Loc.g('Premier vendredi'),
			'-6':	Loc.g('Premier samedi'),
			'-7':	Loc.g('Premier dimanche')
		},
		monthlyMoreLast : {
			'-8':	Loc.g('Dernier lundi'),
			'-9':	Loc.g('Dernier mardi'),
			'-10':	Loc.g('Dernier mercredi'),
			'-11':	Loc.g('Dernier jeudi'),
			'-12':	Loc.g('Dernier vendredi'),
			'-13':	Loc.g('Dernier samedi'),
			'-14':	Loc.g('Dernier dimanche')
		}
	},

	// bindings

	/*
	 * Client:		- docrec_thirdid			type:third,max:1
	 * Contact:		- docrec_linkedthirdid		type:thirdContact,max:1,more:hasemail
	 *				- docrec_recipients			type:thirdContact,more:hasemail
	 * Adresses:	- docrec_thirdaddress		type:third,max:1
	 *				- docrec_shipaddress		type:third,max:1
	 */

	unbindDocument : function(item) {
		 DocRecurring.updateFormCondition('gocardless','model', false);
		 DocRecurring.updateFormCondition('stripe','model', false);
	},

	bindDocument : function(item) {
		$('#docrec_amount').val(item.totalAmount);
		$('#data').find('#doctype').val(item.doctype);
		$('#data').find('#numformat_currency').val(item.currencysymbol);
		if(item.hasSerial) {
			$('#alertSerial').show();
			$('.occBtnBis').css('pointer-events', 'none');
		} else {
			$('#alertSerial').hide();
			$('.occBtnBis').css('pointer-events', 'auto');
		}

		DocRecurring.updateFormCondition('gocardless','model', item.hasDirectdebitModule === "gocardless");
		DocRecurring.updateFormCondition('stripe','model', item.hasDirectdebitModule === "stripe");
	},

	bindContactInput : function(item) {
		var id			= item.id.replace('corporation_', '');
		var more		= 'thirdid_' + id;
		// add addresses (mainaddressid/mainaddressname)
		var thirdAddr	= $("#docrec_thirdaddress");
		var shipAddr	= $("#docrec_shipaddress");

		thirdAddr.tokenInput('clear');
		shipAddr.tokenInput('clear');

		if(item.mainaddressid !== '0') {
			thirdAddr.tokenInput('add', {id: item.mainaddressid, name: item.mainaddressname});
			shipAddr.tokenInput('add', {id: item.mainaddressid, name: item.mainaddressname});
		}

		// contact
		$("#docrec_linkedthirdid").tokenInput('more', more);
		$("#docrec_recipients").tokenInput('more', 'hasemail|'+more);
		$("#docrec_shipaddress").tokenInput('more', id);
		$("#docrec_thirdaddress").tokenInput('more', id);
	},

	unbindContactInput : function(){

		$("#docrec_shipaddress").tokenInput('more', 'none').tokenInput('clear');
		$("#docrec_thirdaddress").tokenInput('more', 'none').tokenInput('clear');

		// contact
		$("#docrec_linkedthirdid").tokenInput('clear');
		$("#docrec_recipients").tokenInput('clear');
		$("#docrec_linkedthirdid").tokenInput('more', '');
		$("#docrec_recipients").tokenInput('more', 'hasemail');

	},

	bindThirdInput : function(item) {
		var third = $('#docrec_thirdid');
		// when you're in edit only mode, not create, you have the thirdid in a sarcastic hidden input

		if(third.type !== 'hidden') {
			// create
			if(third.tokenInput('get').length === 0) {
				var new_id = 'corporation_' + item.linkedid;

				third.tokenInput('clear');
				third.tokenInput('add', {id: new_id, name: item.linkedname, mainaddressid: item.mainaddressid, mainaddressname: item.mainaddressname});
				third.val(new_id);
			}
		}
	},

	checkForDirectdebit : function(e){

		DocRecurring.updateFormCondition('gocardless','mode', $(e.currentTarget).val() == 'auto');
		DocRecurring.updateFormCondition('stripe','mode', $(e.currentTarget).val() == 'auto');

	},

    loadStripeCustomerForThird : function(item){

        var thirdid = item.linkedid;

        MyFacture.post('stripe_stripeDirectdebits', {action : 'getStripeCustomerForThird', thirdid : thirdid}, function(data){
            DocRecurring.updateFormCondition('stripe','third',(data.customerid && data.hascard === "Y"));
        }, "json");

    },

    unloadStripeCustomerForThird : function(item){
        DocRecurring.updateFormCondition('stripe','third', false);
    },

	loadMandateForThird : function(item){

		if($("#directdebit").length > 0){

			var thirdid = item.linkedid;

			MyFacture.post('gocardless_mandates', {action : 'getForThird', thirdid : thirdid}, function(data){

			if(data.status && data.status == 'error'){
				$("#directdebit select[name='docrec_mandateid']").remove();

				DocRecurring.updateFormCondition('gocardless','third', false);

			} else {

				DocRecurring.updateFormCondition('gocardless','third', data.length > 0);

				$.each(data, function(i, item) {

					$("#directdebit select[name='docrec_mandateid'] option[value='']").remove();

					var selected = "";
					if(item.isdefault == 'Y'){
						selected = "selected";
					}

					$("#directdebit select[name='docrec_mandateid']").append( '<option value="' + item.id + '"' + selected + ' data-next_charge_date="' + item.unix_nextPossibleCharge + '">'+ item.labelForSelect + '</option>' );

				});

				if(GoCardless){
					GoCardless.showNextChargeDateAlert($("#directdebit select[name='docrec_mandateid']"), true);
				}

			}

			}, 'json');

		}

	},

	unloadMandateForThird : function(){

		if($("#directdebit")){
			$("#directdebit select[name='docrec_mandateid']").empty();
			DocRecurring.updateFormCondition('gocardless','third', false);
		}
	},

	editRecurring : function(docid, thirdid){
		docid 	= typeof docid !== 'undefined' ? docid : 0;
		thirdid = typeof thirdid !== 'undefined' ? thirdid : 0;
		var options = {
			title	: Loc.g("Programmer votre abonnement"),
			width	: 1200,
			height	: 800,
			buttons	: [
				{
					text	: Loc.g("Annuler"),
					click	: function(){
						$(this).dialog('close');
					}
				}
			],
			callback	: function(){
				DocRecurring.prepareRecurringForm();
				Email.addListenerEmailVerified();
				if(thirdid !== 0){
					var more = 'thirdid_' + thirdid;
					$("#docrec_linkedthirdid").tokenInput('more', more);
					$("#docrec_recipients").tokenInput('more', 'hasemail|'+more);
					$("#docrec_shipaddress").tokenInput('more', thirdid);
					$("#docrec_thirdaddress").tokenInput('more', thirdid);
				}
			}
		};

		var fileOpt = {
			action	: "form",
			docid	: docid,
			thirdid : thirdid
		};
		MyWindow.load("recurring_recurring", fileOpt, options);


	},

	updateFormCondition : function(plugin, key, value){
		DocRecurring.formConditions[plugin][key] = value;
		DocRecurring.showDirectdebitForm(plugin);
	},

	showDirectdebitForm : function(plugin){

        var directdebitForm     =  "#" + plugin + "Form";
        var $directDebitInput   = $('input[name=docrec_useDirectdebit]');
        var formConditions      = DocRecurring.formConditions[plugin];

		if(formConditions.third && formConditions.mode && formConditions.model){

            DocRecurring.directdebitAvailable[plugin] = true;

			$directDebitInput.val(plugin);
            $('#docRecurringForm #directdebit ' + directdebitForm +  ' , #updateRecurringForm #directdebit ' + directdebitForm).removeClass('hidden');

		} else {

            DocRecurring.directdebitAvailable[plugin] = false;

			$('#docRecurringForm #directdebit ' + directdebitForm + ', #updateRecurringForm #directdebit ' + directdebitForm ).addClass('hidden');
		}

        if(DocRecurring.directdebitAvailable["stripe"] || DocRecurring.directdebitAvailable["gocardless"]) {
            $('#useDirectdebit').removeClass('hidden');
            $('#docRecurringForm #directdebit .placeholder, #updateRecurringForm #directdebit .placeholder').addClass('hidden');
        } else {
            $('#docRecurringForm #directdebit .placeholder, #updateRecurringForm #directdebit .placeholder').removeClass('hidden');
            $('#useDirectdebit').addClass('hidden');
            $directDebitInput.val("N");
        }

        $('#docrec_useServiceDates').bind('change', function(event){
            $('#docrec_serviceDateStart').prop('disabled', !this.checked);
            $('#docrec_serviceDateStop').prop('disabled', !this.checked);
            if(this.checked){
                $('#service_date').show();
            } else {
                $('#service_date').hide();
            }
        });


	},

	loadPopupCheckingEmail: function ()
	{
		window.sellsyapp.$store.state.popupPanel.popupCheckSendingEmail.props = { mode: 'checking'}
		window.sellsyapp.$store.state.popupPanel.popupCheckSendingEmail.display = true
	},

	prepareRecurringForm: function() {
		var formId = "docRecurringForm";

		var options = {
			data		: {
				action	: 'formRecord'
			},
			success		: function(data){
				var formIsOk = MyForm.processJson(data, "docRecurringForm");
				if(formIsOk){
					location.reload();
				}
			},
			dataType	: "json"
		};

		MyForm.prepare(formId, "recurring_recurring", options, true);
		MyFacture.initEvent();

		var datepicker = moment();
		datepicker.add(1, 'days');
		$('[datepicker]').datepicker( "option" , 'minDate' , datepicker.toDate());


		// Service Date
        $('#docrec_serviceDateStart').datepicker( "option" , 'minDate' , null);
        $('#docrec_serviceDateStop').datepicker( "option" , 'minDate' , null);

		DocRecurring.changeFrequency();

		$('#docrec_startDate').bind('change', function(event) {
			var target		= event.target;

			var freq		= $('#docrec_frequency').val();
			var dateformat	= $('.occForm').find('#docrec_startDate').attr('format');

			if(freq !== 'weekly' && freq !== 'xdays') {
				var date			= target.value;
				var parts			= date.split('/');

				var indexToTake		= 0;
				switch(dateformat) {
					case 'mdy':
						indexToTake	= 1;
						break;
				}

				$('#docrec_frequencyMore_select').val(parseInt(parts[indexToTake], 10));
			}
			if(freq === 'weekly') {
				var date = target.value;
				var parts = date.split('/');

				var date = null;
				switch (dateformat) {
					case 'dmy':
						date = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
						break;
					case 'mdy':
						date = new Date(parseInt(parts[2]), parseInt(parts[0]) - 1, parseInt(parts[1]));
						break;
				}

				var days = {
					0:6,
					1:0,
					2:1,
					3:2,
					4:3,
					5:4,
					6:5
				};

				$('#docrec_frequencyMore_select').val(days[date.getDay()]);
			}
		});

		$('#docrec_useServiceDates').bind('change', function(event){
            $('#docrec_serviceDateStart').prop('disabled', !this.checked);
            $('#docrec_serviceDateStop').prop('disabled', !this.checked);
        });


		DocRecurring.updateFormCondition('gocardless','mode', $("#docrec_mode").val() === 'auto');
		DocRecurring.updateFormCondition('stripe','mode', $("#docrec_mode").val() === 'auto');

		DocRecurring.updateFormCondition('gocardless','model', $("input[name='docrec_canUseGocardless']").val() === 'Y');
		DocRecurring.updateFormCondition('stripe','model', $("input[name='docrec_canUseStripe']").val() === 'Y');

        DocRecurring.updateFormCondition('gocardless','third', $("select[name='docrec_mandateid'] option[value!='']").length > 0);
        DocRecurring.updateFormCondition('stripe','third', $("input[name='docrec_canUseStripe']").val() === 'Y');
	},

	checkForPromotion : function (e){

		var parent = $('.occForm');
		var v_id = $(e.currentTarget).attr('id');

		if(v_id == 'docrec_usePromotion'){

			if( $(e.currentTarget).is(':checked')){
				parent.find('#docrec_updatePrices').attr('checked', true);
			}

		} else {

			if( !$(e.currentTarget).is(':checked')){
				parent.find('#docrec_usePromotion').attr('checked', false);
			}

		}

	},

	overviewRecurring : function(recurrid){
		var options = {
			title	: Loc.g("Visualisation de l'abonnement"),
			width	: 1200,
			buttons	: [
                {
                    text : Loc.g("Annuler"),
                    click: function(){MyWindow.close();}
                },
                {
				text : Loc.g("Modifier"),
				click: function() {DocRecurring.viewRecurring(recurrid);},
			}
			],
			callback: function(){
				DocRecurring.prepareOverviewRecurring();
			}
		};

		var fileOpt = {
			action		: "overview",
			recurrid	: recurrid
		};

		fileOpt = $.extend(true, fileOpt, DocOverview.getProperties(['docid', 'doctype']));
		MyWindow.load("recurring_recurring", fileOpt, options);
	},

	prepareOverviewRecurring : function() {
		DocRecurring.calcTotal();

		MyFacture.initEvent();
		MyFacture.loadThirdQtip();

		MyTabs.initHorizontal('recurringOverview');
		Annotation.init("recurringComments");
		Qtip.init();

	},

	viewRecurring : function(recurrid) {
		var options = {
			title	: Loc.g("Edition de l'abonnement"),
			width	: 1200,
			buttons	: [
                {
                    text : Loc.g("Annuler"),
					'class': 'btn btn-default',
                    click : function(){
						MyWindow.close();
					}
                },
                {
					text : Loc.g('Enregistrer'),
					'class': 'btn btn-primary',
					click: function() {
						$('#updateRecurringForm').submit();
					}
				}
			],
			callback: function(){
				DocRecurring.prepareViewRecurring();
			}
		};

		var fileOpt = {
			action		: "updateForm",
			recurrid	: recurrid
		};

		fileOpt = $.extend(true, fileOpt, DocOverview.getProperties(['docid', 'doctype']));
		MyWindow.load("recurring_recurring", fileOpt, options);
	},

	prepareViewRecurring : function() {
		var formId = 'updateRecurringForm';

		DocRecurring.calcTotal();

		var options = {
			success		: function(data){
				DocRecurring.updateRecurringCallback(data);
			},
			dataType	: "json"
		};
		var params = {
			action:'updateRecord'
		};
		params = $.extend(true, params, DocOverview.getProperties(['docid', 'doctype']));
		MyForm.prepare(formId, "recurring_recurring&"+$.param(params), options, true);
		MyFacture.initEvent();

		var myscroll = $('tbody.occScrollContent');
		myscroll.scrollTop(myscroll.get(0).scrollHeight);

		DocRecurring.updateFormCondition('gocardless','mode', $("#new_genMode").val() === 'auto');
		DocRecurring.updateFormCondition('stripe','mode', $("#new_genMode").val() === 'auto');

        DocRecurring.updateFormCondition('stripe','third', $("input[name='docrec_canUseStripe']").val() === 'Y');
        DocRecurring.updateFormCondition('stripe','model', $("input[name='docrec_canUseStripe']").val() === 'Y');

        DocRecurring.updateFormCondition('gocardless','third', $("select[name='docrec_mandateid'] option[value!='']").length > 0);
		DocRecurring.updateFormCondition('gocardless','model', $("input[name='docrec_canUseGocardless']").val() === 'Y');

	},

	updateRecurringCallback : function(data) {
		var formIsOk = MyForm.processJson(data, "updateRecurringForm");
		Utils.reload();
	},

	changeFrequency : function(){
		var more = $('#frequencyMore');
		var freq = $("#docrec_frequency").val();

		// set frequencyMore label
		var moreLabel = more.find('label');
		switch(freq) {
			case 'weekly':
				moreLabel.text(this.freqMore_label.week);
				break;
			case 'xdays':
				moreLabel.text(this.freqMore_label.xdays);
				break;
			default:
				moreLabel.text(this.freqMore_label.month);
				break;
		}

		// mettre le bon input
		var selectIsVisible	= null;
		var selectP			= $('#docrec_frequencyMore_select').parent();
		var textP			= $('#docrec_frequencyMore_text').parent();

		switch(freq) {
			case 'xdays':
				selectP.hide();
				textP.show();
				selectIsVisible = false;
				break;
			default:
				selectP.show();
				textP.hide();
				selectIsVisible = true;
				break;
		}

		// si le select est visible, on le remplit comme il faut ...
		if( selectIsVisible) {

			var data = null;

			switch(freq) {
				case 'weekly':
					data = this.freqMore_values.weekly;
					break;
				default:
					data = this.freqMore_values.monthly;
					break;
			}

			var selectParent = $('#docrec_frequencyMore_select').parent();
			$('#docrec_frequencyMore_select').remove();

			var select = $('<select name="docrec_frequencyMore_select" id="docrec_frequencyMore_select"></select>');

			if(freq !== 'weekly') {
				for(var key in DocRecurring.freqMore_values.monthlyMoreFirst) {
					var option = $('<option></option>');
					option.text(DocRecurring.freqMore_values.monthlyMoreFirst[key]);
					option.attr('value', key);
					select.append(option);
				}
			}

			for(var key in data) {
				var option = $('<option></option>');
				option.text(data[key]);
				if(freq === 'weekly') {
					option.attr('value', key);
				} else {
					option.attr('value', data[key]);
				}
				select.append(option);
			}

			if(freq !== 'weekly') {
				for(var key in DocRecurring.freqMore_values.monthlyMoreLast) {
					var option = $('<option></option>');

					option.text(DocRecurring.freqMore_values.monthlyMoreLast[key]);
					option.attr('value', key);
					select.append(option);
				}
			}

			selectParent.append(select);
			MyFacture.customForm('#docRecurringForm');

			if(freq !== 'weekly' && freq !== 'xdays') {
				$('#docrec_startDate').trigger('change');
			}
		}
	},

	confirmRecurringDelete : function(recurrid, docid){
		var options = {
			width		: 400,
			resizable	: false,
			noclose		: true,
			type		: 'warning',
			title		: Loc.g("Suppression de la récurrence sur la facture"),
			buttons		: [
                {
					text	: Loc.g("Annuler"),
					click	: function(){
						$(this).dialog("close");
					}
				},
                {
					text	: Loc.g("Valider"),
					click	: function(){

						MyFacture.post(
							"recurring_recurring",
							{
								action:"delete",
								recurrid : recurrid,
								docid : docid
							},
							function(data) {
								DocRecurring.deleteRecurringCallback(data);
							},
							"json"
						);
					}
				}
			]
		};

		MyWindow.alert(Loc.g("Valider pour supprimer l‘abonnement"), options);
	},

	deleteRecurringCallback: function(data){
		if(data.delrecurrid){
			Utils.reload();
		}
	},

	regenerateOcc: function(id) {
		var btn = $('#btnRegenerate_'+id);
		btn.attr('onclick', false).attr('disabled', 'disabled').addClass('ui-state-disabled');

		MyFacture.post(
			'recurring_recurring',
			{
				action		: 'regenerate',
				recgenid	: id
			},
			function(data) {
				if(data.result != false && !data.status) {
					Push.success(Loc.g('La génération de la facture de l\'occurence d\'abonnement est planifiée. La facture sera disponible dans quelques minutes.'));
				} else {
					Push.error(Loc.g('Votre occurence ne peut être générée.'));
				}

				if(data.recurring){
					MyWindow.close();
					DocRecurring.overviewRecurring(data.recurring);
				}

			}
		);
	},

	prepareFilterForm: function() {

		var options = {
			data		: {
				action : 'updateListing'
			},
			success		: function (data) {
				DocRecurring.processFilterForm(data);
			},
			dataType	: "json"
		};

		MyForm.prepare("docrecurringFilterForm", "recurring_listing", options);
	},

	prepareGeneratedFilterForm: function() {

        var options = {
			data		: {
				action	: 'updateGeneratedListing'
			},
			success		:function(data){
				DocRecurring.processGeneratedFilterForm(data);
			},
			dataType	:"json"
		};

        MyForm.prepare("docrecurringgeneratedFilterForm", "recurring_listing", options);
	},

	prepareModelFilterForm: function(docid) {

		var options = {
			data	: {
				action	: 'updateModelListing',
				docid	: docid
			},
			success:function(data){
				DocRecurring.processModelFilterForm(data);
			},
			dataType:"json"
		};

        MyForm.prepare("docmodelrecurringFilterForm", "recurring_listing", options);
	},

	processFilterForm: function(data){
		DocRecurring.buildPagenum(data.docrecurring_metadatas.pagenum, data.docrecurring_metadatas.nbPages);
		Listing.refresh("docrecurringListing", data, data.docrecurring_metadatas);
	},

	processGeneratedFilterForm: function(data){
		DocRecurring.buildPagenum(data.docrecurringgenerated_metadatas.pagenum, data.docrecurringgenerated_metadatas.nbPages);
		Listing.refresh("docrecurringgeneratedListing", data, data.docrecurringgenerated_metadatas);
	},

	processModelFilterForm: function(data){
		DocRecurring.buildPagenum(data.docmodelrecurring_metadatas.pagenum, data.docmodelrecurring_metadatas.nbPages);
		Listing.refresh("docmodelrecurringListing", data, data.docmodelrecurring_metadatas);
	},

	buildPagenum: function(pagenum, nbpage){},

	viewSchedule : function(recurrId, year){
		var options = {
			title	: Loc.g("Echéancier de l'abonnement"),
			buttons	: [
				{text : Loc.g("Fermer"), click : function(){$(this).dialog("close");}}
			],
			width:600,
			callback	: function(){DocRecurring.prepareRecurringForm();}
		};

		var fileOpt = {action : "scheduleList", recurrId : recurrId};

		if(year != undefined){
			fileOpt.year = year;
		}

		MyWindow.load("recurring_listing", fileOpt, options);
	},

// newRecurringForm
	changeButtons : function() {
		MyWindow.addOption('buttons', [
            {
                text	: Loc.g("Annuler"),
				'class' : 'btn btn-default',
                click	: function () {
                    $(this).dialog('close');
                }
            },
			{
				text	: Loc.g('Enregistrer'),
				'class' : 'btn btn-primary',

				click	: function() {
					$('#docRecurringForm').submit();
				}
			}
		]);
	},

	addOccRow : function( dateFormat, mode, amount, freqs, updateArray) {

		// defaults
		freqs		= typeof freqs		!== 'undefined'	? freqs		: {
			freq		:	$('#docrec_frequency').val(),
			freqMore	:	DocRecurring.getFreqMore()
		};
		dateFormat	= typeof dateFormat !== 'undefined'	? dateFormat: $('.occForm').find('#docrec_startDate').attr('format');
		mode		= typeof mode		!== 'undefined'	? mode		: $('#docrec_mode').val();
		amount		= typeof amount		!== 'undefined'	? amount	: $('#docrec_amount').val();

		// get new row id & increment hidden field
		var s_id	= $('#row_data').find('#rows_nb');
		var id		= parseInt(s_id.val());
		s_id.val(id+1);

		if(updateArray) {
			var dom = $('#nb_array');

			if(dom.length > 0) {
				var oVal = dom.val();
				dom.val(oVal+','+id);
			}
		}

		/////////////////////////////////////////////////////////////////////////////////
		///// create new row
		/////////////////////////////////////////////////////////////////////////////////
		// clone
		var new_row = $('#row_template')
				.clone()
				.attr('id', 'row_'+id)
				.addClass('occRow')
				.removeClass('hidden')
				.show();

		/////////////////////////////////////////////////////////////////////////////////
		// change date
		var table = $('.occScrollContent').find('tr.occRow');

		// prendre la date dans le form
		var lastDate = null;
		var startDate = $('#docrec_startDate').val();
		var dNext = dLast;
		if( table.length > 0) {
			// if first row
			var lastRow = table.last();
			lastDate = lastRow.find('input.occDate').val();
			if(lastDate === undefined) {
				lastDate = lastRow.find('.occDate').html();
			}

			// parse date
			var dLast = null;
			switch( dateFormat) {
				case 'mdy':
					dLast = Date.parseExact(lastDate, 'MM/dd/yyyy');
					break;
				default:
				case 'dmy':
					dLast = Date.parseExact(lastDate, 'dd/MM/yyyy');
					break;
			}
			dNext = DocRecurring.calcDate(dLast, freqs);
		} else {
			lastDate = startDate;

			// parse date
			var dLast = null;
			switch( dateFormat) {
				case 'mdy':
					dLast = Date.parseExact(lastDate, 'MM/dd/yyyy');
					break;
				case 'dmy':
					dLast = Date.parseExact(lastDate, 'dd/MM/yyyy');
					break;
			}
			dNext = DocRecurring.calcDate(dLast, freqs, true);
		}

		/////////////////////////////////////////////////////////////////////////////////
		var occDate = new_row.find('input');
		switch( dateFormat) {
			case 'mdy':
				occDate.val(dNext.toString('MM/dd/yyyy'));
				break;
			case 'dmy':
				occDate.val(dNext.toString('dd/MM/yyyy'));
				break;
		}
		occDate.attr('id', 'row_'+id+'_date');
		occDate.attr('name', 'row_'+id+'_date');

		/////////////////////////////////////////////////////////////////////////////////
		// change mode
		var occMode = new_row.find('.occMode').find('select');
		occMode.attr('id', 'row_'+id+'_mode');
		occMode.attr('name', 'row_'+id+'_mode');
		occMode.val(mode);

		/////////////////////////////////////////////////////////////////////////////////
		// change amount


		var numformat = DocRecurring.getNumFormat();

		//case empty numberformat when new recurring, we get corp numformat
		if (numformat.decimals == '') {
			numformat = window.App.numformat;
		}

		var formatedAmount = NumberFormat.formatToDisplay(amount, numformat);
		if( NumberFormat.currencyToRight(numformat)) {
			formatedAmount = formatedAmount + ' ' + numformat.currency;
		}
		if( NumberFormat.currencyToLeft(numformat)) {
			formatedAmount = numformat.currency + ' ' + formatedAmount;
		}

		var occAmount = new_row.find('.occAmount');
		occAmount.text(formatedAmount);
		occAmount.data('amount', amount);

		/////////////////////////////////////////////////////////////////////////////////
		// change remove row_id
		new_row.find('.occBtn_delete').attr('onclick', 'DocRecurring.removeOccRow(' +id+ ');');

		$('#contentList').find('.occTable').append(new_row);
		var myscroll = $('tbody.occScrollContent');
		myscroll.scrollTop(myscroll.get(0).scrollHeight);

		return new_row;
	},

	getFreqMore : function() {
		var freqMore = null;
		if( $('#docrec_frequencyMore_select').parent().is(':hidden')) {
			freqMore = $('#docrec_frequencyMore_text').val();
		} else {
//			freqMore = $('#docrec_frequencyMore_select').selectmenu().val();
			freqMore = $('#docrec_frequencyMore_select').val();
		}
		return freqMore;
	},

	calcDate : function(dLast, freqs, isFirstDate) {

		var isFirstDate = (isFirstDate == undefined) ? false : isFirstDate;

		var intFreqMore = parseInt(freqs.freqMore);

		// no dLast case (eg. no occurences)
		if (dLast === null) {
			dLast = new Date();
		}
		var dNext = dLast;

		switch (freqs.freq) {
			case 'weekly':

				if(isFirstDate){

					var days = { 0:6, 1:0, 2:1, 3:2, 4:3, 5:4, 6:5 };

					if(days[dLast.getDay()] == intFreqMore) {
						dNext = dLast;
					} else {
						dNext = DocRecurring.calcDate(dLast, freqs);
					}

				} else {

					var day = 'monday';

					switch(freqs.freqMore) {
						case '0' : day = 'monday';		break;
						case '1' : day = 'tuesday';		break;
						case '2' : day = 'wednesday';	break;
						case '3' : day = 'thursday';	break;
						case '4' : day = 'friday';		break;
						case '5' : day = 'saturday';	break;
						case '6' : day = 'sunday';		break;
					}

					dNext[day]();
				}

				break;
			case 'monthly':
			case 'bimonthly':
			case 'quarterly':
			case 'biannual':
			case 'annual':

				if(intFreqMore >= 0) {

					if(isFirstDate){

                        if(parseInt(dNext.toString('dd')) < intFreqMore){
                            switch(freqs.freq) {
                                case 'monthly'	: dNext.addMonths(-1); 	break;
                                case 'bimonthly': dNext.addMonths(-2); 	break;
                                case 'quarterly': dNext.addMonths(-3); 	break;
                                case 'biannual'	: dNext.addMonths(-6); 	break;
                                case 'annual'	: dNext.addMonths(-12);	break;
                            }
                        }


						if(dLast.getDate() !== intFreqMore) {
							dNext = DocRecurring.calcDate( dLast, freqs);
						}

					} else {
						switch(freqs.freq) {
							case 'monthly'	: dNext.addMonths(1); 	break;
							case 'bimonthly': dNext.addMonths(2); 	break;
							case 'quarterly': dNext.addMonths(3); 	break;
							case 'biannual'	: dNext.addMonths(6); 	break;
							case 'annual'	: dNext.addMonths(12);	break;
						}

						if(dNext.getDate() !== intFreqMore) {
							var daysInMonth = Date.getDaysInMonth(dNext.getYear(), dNext.getMonth());

							if(intFreqMore > daysInMonth) {
								intFreqMore = daysInMonth;
							}

							dNext.set({ day:intFreqMore });
						}
					}


				} else {

					var dNext = new Date(dLast.getTime());

					if(isFirstDate){
						dNext.set({ day: 1});
					} else {
						switch(freqs.freq) {
							case 'bimonthly': dNext.addMonths(1); 	break;
							case 'quarterly': dNext.addMonths(2); 	break;
							case 'biannual'	: dNext.addMonths(5); 	break;
							case 'annual'	: dNext.addMonths(11);	break;
						}

						var month = 'january';

						switch(dNext.getMonth()) {
							case 0	: month = 'february';	break;
							case 1	: month = 'march';		break;
							case 2	: month = 'april';		break;
							case 3	: month = 'may';		break;
							case 4	: month = 'june';		break;
							case 5	: month = 'july';		break;
							case 6	: month = 'august';		break;
							case 7	: month = 'september';	break;
							case 8	: month = 'october';	break;
							case 9	: month = 'november';	break;
							case 10	: month = 'december';	break;
							case 11	: month = 'january';	break;
						}

						dNext[month]();
					}

					var movePosition = (intFreqMore <= -1 && intFreqMore >= -7) ? 'first' : 'last';

					switch (movePosition){
						case 'first':
							// Cursor to the last day of the previous month
							dNext.moveToFirstDayOfMonth().addDays(-1);
							break;
						case 'last':
							// Cursor to the 1st day of the next month
							dNext.moveToLastDayOfMonth().addDays(1);
							break;
					}

					var day = 'monday';

					switch(intFreqMore) {
						case -1	: // lundi
						case -8	: day = 'monday';		break;

						case -2	: // mardi
						case -9	: day = 'tuesday';		break;

						case -3	: // mercredi
						case -10: day = 'wednesday';	break;

						case -4	: // jeudi
						case -11: day = 'thursday';		break;

						case -5	: // vendredi
						case -12: day = 'friday';		break;

						case -6	: // samedi
						case -13: day = 'saturday';		break;

						case -7	: // dimanche
						case -14: day = 'sunday';		break;
					}

					switch (movePosition){
						case 'first':
							// Current cursor is the last day of the previous month
							dNext.next()[day]();
							break;
						case 'last':
							// Current cursor is the 1st day of the next month
							dNext.prev()[day]();
							break;
					}

					if(dNext < dLast) {
						dNext = DocRecurring.calcDate(dNext, freqs);
					}

				}
				break;

			case 'xdays':

				if (!isFirstDate) {
					dNext = dLast.addDays(intFreqMore);
				}

				break;

		}

		// si ça plante
		if( dNext === null) {
			dNext = dLast;
		}

		return dNext;
	},

	removeOccRow : function(id) {
		$('#row_'+id).remove();
		DocRecurring.calcTotal();
	},

	checkRecurringForm : function() {

		function isNormalInteger(str) {
			var n = ~~Number(str);
			return String(n) === str && n > 0;
		};

		var isOkay		= true;
		var dateformat	= $('.occForm').find('#docrec_startDate').attr('format');

		// check dateStart
		var date		= $('#docRecurringForm #docrec_startDate').val();
		var now			= new Date();
		var dateStart	= null;

		switch(dateformat) {
			case 'mdy':
				dateStart = Date.parseExact(date, 'M/d/yyyy');
				break;
			case 'dmy':
				dateStart = Date.parseExact(date, 'd/M/yyyy');
				break;
		}

		if( date === '' || now >= dateStart) {
			var elStartDate = $('#docRecurringForm #docrec_startDate');

			elStartDate.val('')
					.addClass('ui-state-error')
					.attr( 'placeholder', Loc.g('La date a besoin d\'être supérieure à aujourd\'hui'))
					.on('focus', function() {
						$('#docRecurringForm #docrec_startDate').attr( 'placeholder', '');
						$('#docRecurringForm #docrec_startDate').removeClass('ui-state-error');
						$('#docRecurringForm #docrec_startDate').unbind('focus');
					});

			isOkay = false;
		} else {
			if( $('#docRecurringForm #docrec_startDate').hasClass('ui-state-error')) {
				$('#docRecurringForm #docrec_startDate').removeClass('ui-state-error');
			}
		}

		var elNbOcc = $('#docRecurringForm #docrec_nbOcc');
		var nbOcc	= elNbOcc.val();

		if( nbOcc === '' | !isNormalInteger(nbOcc) | (parseInt(nbOcc,10) < 0 || parseInt(nbOcc,10) > 60)) {

			elNbOcc.val('')
				.addClass('ui-state-error')
				.attr( 'placeholder', Loc.g('Entre 0 et 60'))
				.on('focus', function() {
					$('#docRecurringForm #docrec_nbOcc').attr( 'placeholder', '');
					$('#docRecurringForm #docrec_nbOcc').removeClass('ui-state-error');
					$('#docRecurringForm #docrec_nbOcc').unbind('focus');
				});

			isOkay = false;

		} else if( elNbOcc.hasClass('ui-state-error')) {
			elNbOcc.removeClass('ui-state-error');
		}

		var elDocToken = $('#docRecurringForm #docrec_docid');

		if(elDocToken.attr('type') === 'text') {

			var docToken	= elDocToken.tokenInput('get');
			docToken		= docToken[0];

			if(typeof(docToken) === "undefined" ) {

				var toModify = elDocToken.parent().find('ul');

				toModify.addClass('ui-state-error');
				toModify.find('input')
						.attr('style', 'outline: none; width: 40px; background-color: #ffe3e8 !important;');

				toModify.find('input')
						.on('focus', function() {
							var toModify = $('#docRecurringForm #docrec_docid').parent().find('ul');

							toModify.removeClass('ui-state-error');
							toModify.find('input').attr('style', 'outline: none; width: 40px;');
						});

				isOkay = false;
			}
		}

		var elThirdToken	= $('#docRecurringForm #docrec_thirdid');
		var thirdToken		= elThirdToken.tokenInput('get');
		thirdToken			= thirdToken[0];
		if(typeof(thirdToken) === "undefined") {

			var toModify = elThirdToken.parent().find('ul');

			toModify.addClass('ui-state-error');

			toModify.find('input')
					.attr('style', 'outline: none; width: 40px; background-color: #ffe3e8 !important;');

			toModify.find('input')
					.on('focus', function() {
						var toModify = $('#docRecurringForm #docrec_thirdid').parent().find('ul');

						toModify.removeClass('ui-state-error');
						toModify.find('input').attr('style', 'outline: none; width: 40px;');
					});

			isOkay = false;
		}

		return isOkay;
	},

	resetOccData : function() {

		$('table.occTable tbody .occRow').each(function(i,e){
			e.remove();
		});

	},

	generate : function() {
		if( DocRecurring.checkRecurringForm()) {

			$('table.occTable').find('tbody').find('tr.occPlaceholder').remove();
			$('#generateOneRow').show();
			$('#contentList').show();

			DocRecurring.changeButtons();
			DocRecurring.resetOccData();
			DocRecurring.generateOccData();

		}
	},

	generateOccData : function() {
		var nbOcc		= $('#docRecurringForm').find('#docrec_nbOcc').val();

		var dateFormat	= $('.occForm').find('#docrec_startDate').attr('format');
		var mode		= $('#docrec_mode').val();
		var amount		= $('#docrec_amount').data('amount');

		var freqs		= {
			freq		:	$('#docrec_frequency').val(),
			freqMore	:	DocRecurring.getFreqMore()
		};

		for(var i = 0; i < nbOcc; i++) {
			DocRecurring.addOccRow(dateFormat, mode, amount, freqs);
		}

		DocRecurring.calcTotal();
		MyFacture.customForm('#contentList');
	},

	generateOneRow : function() {

		var dateFormat	= $('.occDate').find('input').attr('format');
		var lastRow		= $('.occTable').find('tbody').find('.occRow:last');
		var amount		= lastRow.find('.occAmount').data('amount');
		var mode		= lastRow.find('.occMode').find('select').val();

		var freqs = {
			freq		: $('#docrec_freq').val(),
			freqMore	: $('#docrec_freqMore').val()
		};

		if(	freqs.freq		=== undefined &&
			freqs.freqMore	=== undefined) {
			freqs = undefined;
		}

		DocRecurring.addOccRow(dateFormat, mode, amount, freqs, true);
		DocRecurring.calcTotal();
		MyFacture.customForm('#contentList');
	},

	calcTotal : function() {

		var amount			= 0;
		var amountGenerated	= 0;
		var amountComing	= 0;

		$('table.occTable').find('tbody').find('.occRow').each(function(i,e) {

			var isGenerated = ($(e).attr('data-generated') === 'Y');
			var tmp			= $(e).find('.occAmount').data('amount');
			// calc total due per row
			if(tmp){

				tmp = tmp.replace(',', '.');
				tmp = parseFloat(tmp);
				amount += tmp;

				if(isGenerated) {
					amountGenerated += tmp;
				} else {
					amountComing += tmp;
				}
			}

		});

		// row_totalAmountGenerated
		var totalGenerated = $('#row_totalAmountGenerated');
		if( amountGenerated > 0) {
			totalGenerated.show();
		} else {
			totalGenerated.hide();
		}
		// row_totalAmountComing
		var totalComing = $('#row_totalAmountComing');
		if( amountComing > 0) {
			totalComing.show();
		} else {
			totalComing.hide();
		}
		// row_totalAmountDue
		var totalDue = $('#row_totalAmountDue');
		if( totalDue.is(':hidden')) {
			totalDue.show();
		}

		var numformat				= DocRecurring.getNumFormat();
		var formatedAmount			= NumberFormat.formatToDisplay(amount, numformat);
		var formatedAmountGenerated = NumberFormat.formatToDisplay(amountGenerated, numformat);
		var formatedAmountComing	= NumberFormat.formatToDisplay(amountComing, numformat);

		if( NumberFormat.currencyToRight(numformat)) {
			formatedAmount			= formatedAmount + ' ' + numformat.currency;
			formatedAmountGenerated = formatedAmountGenerated + ' ' + numformat.currency;
			formatedAmountComing	= formatedAmountComing + ' ' + numformat.currency;
		} else {
			formatedAmount			= numformat.currency + ' ' + formatedAmount;
			formatedAmountGenerated = numformat.currency + ' ' + formatedAmountGenerated;
			formatedAmountComing	= numformat.currency + ' ' + formatedAmountComing;
		}

		totalDue.find('.occTotalAmount').text(formatedAmount);
		totalGenerated.find('.occTotalAmountGenerated').text(formatedAmountGenerated);
		totalComing.find('.occTotalAmountComing').text(formatedAmountComing);
	},

	getNumFormat : function() {
		var temp = $('#data');
		return {
			name		: "",
			decimals	: temp.find("#numformat_decimals").val(),
			thousands	: temp.find('#numformat_thousand').val(),
			currency	: temp.find('#numformat_currency').val(),
			currencypos	: temp.find('#numformat_currencypos').val(),
			precision	: parseInt(temp.find('#numformat_precision').val(), 10)
		};
	},

	changeModeInUpdate : function() {

		var genMode = $('#new_genMode').val();

		$('.occTable td.occMode:visible select').each(function() {
			$(this).val(genMode);
		});

	},

	toggleWarehouseSelect: function(el) {

		if($(el).prop('checked')) {
			$('#warehouseSelect').show();
		} else {
			$('#warehouseSelect').hide();
		}
	},
};
